import { isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import Notiflix from 'notiflix';
import { EnquireService } from '../../services/enquire.service';
import { BrochureService } from '../../services/brochure.service';

@Component({
  selector: 'app-nav',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './nav.html',
  styleUrl: './nav.css'
})
export class NavComponent implements OnInit {
  scrolled = false;
  enquireOpen = false;
  brochureOpen = false;
  mobileMenuOpen = false;

  form = { name: '', email: '', phoneNumber: '', message: '', company: '' };
  brochureForm = { name: '', email: '', phoneNumber: '', company: '' };

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private http: HttpClient,
    private enquireService: EnquireService,
    private brochureService: BrochureService
  ) {}

  ngOnInit() {
    this.enquireService.open$.subscribe(() => this.openEnquire());
    this.brochureService.open$.subscribe(() => this.openBrochure());
  }

  @HostListener('window:scroll')
  onScroll() {
    if (!isPlatformBrowser(this.platformId) || typeof window === 'undefined') return;
    this.scrolled = window.scrollY > 80;
  }

  @HostListener('window:keydown.escape')
  onEscape() {
    this.closeEnquire();
    this.closeBrochure();
  }

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
    if (isPlatformBrowser(this.platformId)) {
      document.body.style.overflow = this.mobileMenuOpen ? 'hidden' : '';
    }
  }

  closeMobileMenu() {
    this.mobileMenuOpen = false;
    if (isPlatformBrowser(this.platformId)) {
      document.body.style.overflow = '';
    }
  }

  openEnquire() {
    this.enquireOpen = true;
    this.mobileMenuOpen = false;
    if (isPlatformBrowser(this.platformId)) {
      document.body.style.overflow = 'hidden';
    }
  }

  closeEnquire() {
    this.enquireOpen = false;
    if (isPlatformBrowser(this.platformId)) {
      document.body.style.overflow = '';
    }
  }

  openBrochure() {
    this.brochureOpen = true;
    if (isPlatformBrowser(this.platformId)) {
      document.body.style.overflow = 'hidden';
    }
  }

  closeBrochure() {
    this.brochureOpen = false;
    if (isPlatformBrowser(this.platformId)) {
      document.body.style.overflow = '';
    }
  }

  submitBrochure() {
    if (!this.brochureForm.name || !this.brochureForm.email) {
      Notiflix.Notify.warning('Please enter your name and email to continue.', {
        timeout: 4000, position: 'right-top', cssAnimationStyle: 'fade',
      });
      return;
    }

    Notiflix.Loading.circle('Sending...');

    const payload = {
      recipients: ['laban@fameve.com', 'partner@karimcgvisuals.com', 'sales@acacia.ke'],
      data: { ...this.brochureForm, website: 'acacia' },
    };

    this.http.post('https://www.blinkstudio.co.ke/send-test-email', payload).subscribe({
      next: () => {
        Notiflix.Loading.remove();
        Notiflix.Notify.success('Your brochure is downloading. Our team will be in touch.', {
          timeout: 5000, position: 'right-top', cssAnimationStyle: 'fade',
          success: { background: '#3b2e1a', textColor: '#e8d5a3', notiflixIconColor: '#c9a96e' }
        });
        this.triggerDownload();
        this.brochureForm = { name: '', email: '', phoneNumber: '', company: '' };
        this.closeBrochure();
      },
      error: () => {
        Notiflix.Loading.remove();
        Notiflix.Notify.success('Your brochure is downloading. Our team will be in touch.', {
          timeout: 5000, position: 'right-top', cssAnimationStyle: 'fade',
          success: { background: '#3b2e1a', textColor: '#e8d5a3', notiflixIconColor: '#c9a96e' }
        });
        this.triggerDownload();
        this.brochureForm = { name: '', email: '', phoneNumber: '', company: '' };
        this.closeBrochure();
      },
    });
  }

  private triggerDownload() {
    if (isPlatformBrowser(this.platformId)) {
      const link = document.createElement('a');
      link.href = '/documents/Acacia_A1_Brochure.pdf';
      link.download = 'Acacia_A1_Brochure.pdf';
      link.click();
    }
  }

  scrollToContact() {
    if (!isPlatformBrowser(this.platformId) || typeof document === 'undefined') return;
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  }

  submitEnquire() {
    if (!this.form.name || !this.form.email) {
      Notiflix.Notify.warning('Please fill in your name and email address.', {
        timeout: 4000, position: 'right-top', cssAnimationStyle: 'fade',
      });
      return;
    }

    Notiflix.Loading.circle('Sending...');

    const payload = {
      recipients: ['laban@fameve.com', 'partner@karimcgvisuals.com', 'sales@acacia.ke'],
      data: { ...this.form, website: 'acacia' },
    };

    this.http.post('https://www.blinkstudio.co.ke/send-test-email', payload).subscribe({
      next: () => {
        Notiflix.Loading.remove();
        Notiflix.Notify.success('Thank you. Our team will be in touch shortly.', {
          timeout: 5000, position: 'right-top', cssAnimationStyle: 'fade',
          success: { background: '#3b2e1a', textColor: '#e8d5a3', notiflixIconColor: '#c9a96e' }
        });
        this.form = { name: '', email: '', phoneNumber: '', message: '', company: '' };
        this.closeEnquire();
      },
      error: () => {
        Notiflix.Loading.remove();
        Notiflix.Notify.failure('Something went wrong. Please try again.', {
          timeout: 4000, position: 'right-top', cssAnimationStyle: 'fade',
        });
        this.closeEnquire();
      },
    });
  }
}
